import React, { useEffect, useState } from "react";
import Header from "../components/Header/Header";
import MobileNavbar from "../components/Header/Mobile/MobileNavbar";
import MobileHeader from "../components/Header/Mobile/MobileHeader";

import avatar from "../images/avatar.png";
import { getData } from "../services/API";
import Loading from "../components/shared/Loading";
import AcademyCard from "../components/Academy/AcademyCard";
import NewAcademyCard from "../components/Academy/NewAcademyCard";
import AcademyCardLoading from "../components/Academy/AcademyCardLoading";
import Footer from "../components/Footer/Footer";
import { useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import NewAcademyCardLoading from "../components/Academy/NewAcademyCardLoading";

const TeacherProfile = () => {
  const [loading, setLoading] = useState(true);
  const [teacherInfo, setTeacherInfo] = useState({});

  const param = useParams("slug");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    getData(`/acd/teacher/show/${param.slug}`, {}, true)
      .then((res) => {
        setTeacherInfo(res.data);
        setLoading(false);
      })
      .catch((res) => {
        //   toastErr.current.show({
        //     severity: "error",
        //     summary: "خطا هنگام دریافت دوره ها",
        //     detail: "لطفا دوباره صفحه را بارگذاری کنید",
        //     life: 3500,
        //   });
      });
  }, []);

  return (
    <div className="blog flex flex-col items-center lg:gap-10 justify-center">
      <Header />
      <MobileNavbar />
      <MobileHeader />

      <div className="w-full max-w-[1300px] h-auto flex flex-col pb-20 gap-7 px-3 2xl:px-0">
        <div className="flex flex-col gap-5">
          <div className="flex items-center gap-4">
            {loading ? (
              <>
                <Skeleton className="w-32 h-32 block sm:w-36 sm:h-36 rounded-full -mb-4" />

                <div className="flex flex-col gap-2">
                  <Skeleton className="w-44 h-8 rounded-xl" />
                  <Skeleton className="w-44 h-8 rounded-xl" />
                </div>
              </>
            ) : (
              <>
                <img
                  src={
                    teacherInfo.teacher.image
                      ? `https://api.myunibest.com/${teacherInfo.teacher.image}`
                      : avatar
                  }
                  className="w-32 h-32 sm:w-36 sm:h-36 object-cover object-top rounded-full"
                  alt=""
                />

                <div className="flex flex-col gap-2">
                  <h1 className="text-gray-200 text-2xl sm:text-3xl font-black">
                    {teacherInfo.teacher.name}
                  </h1>
                  <h2 className="text-gray-400 text-xl sm:text-2xl font-bold">
                    {teacherInfo.teacher.name_en
                      ? teacherInfo.teacher.name_en
                      : ""}
                  </h2>
                </div>
              </>
            )}
          </div>

          {loading ? (
            <Skeleton count={7} className="w-full block h-4 rounded-lg -mb-3" />
          ) : (
            <p className="text-gray-300 text-sm sm:text-base text-justify sm:text-right leading-7 whitespace-pre-wrap">
              {teacherInfo.teacher.description}
            </p>
          )}
        </div>

        <div className="flex flex-col items-center gap-4">
          <div className="flex items-center self-start gap-2">
            <span className="block w-5 h-2 bg-yellow-700 rounded-full"></span>
            <h3 className="text-gray-200 text-2xl font-black">دوره ها</h3>
          </div>

          <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
            {loading ? (
              <>
                <NewAcademyCardLoading />
                <NewAcademyCardLoading />
                <NewAcademyCardLoading />
                <NewAcademyCardLoading />
                <NewAcademyCardLoading />
              </>
            ) : teacherInfo.lessons.length > 0 ? (
              teacherInfo.lessons.map(
                (course) =>
                  course.lessons && <NewAcademyCard data={course.lessons} />
              )
            ) : (
              <span className="text-gray-200">
                دوره ای برای این مدرس ثبت نشده !
              </span>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TeacherProfile;
